var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{active: _vm.active},attrs:{"tabindex":"0"},on:{"focusout":_vm.onFocusOut}},[_c('button',{staticClass:"dropdown-button",on:{"click":_vm.onButtonClick}},[_vm._t("button"),_vm._v(" "),_c('div',{staticClass:"dropdown-arrow",class:{upwardsArrow: _vm.active}})],2),_vm._v(" "),_c('div',{staticClass:"dropdown-list"},[_vm._t("dropdown")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1604e1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Dropdown.vue
// module id = apiZ
// module chunks = 0